import { ResourceOptions } from 'react-admin';
import { MdOutlinePendingActions } from 'react-icons/md';
import { Resources } from '../resource';

export { default as list } from './List';

export const name = Resources.xpxPerpsWithdrawal;
export { XPX_PERPS_WITHDRAWAL_PERMISSION_RESOURCE } from './constants';
export const icon = MdOutlinePendingActions;
export const options: ResourceOptions = {
  label: 'module.xpxPerpsWithdrawal.title',
};
